import React from 'react';
import BouncingImage from '../../BouncingImage';

const TutorialTooltip = ({
  step,
  onNext,
  onComplete,
  style,
  steps,
  nextButtonDisabled = false,
}) => {
  const isLastStep = step.id === steps[steps.length - 1].id;
  const arrowOrientation = style?.['--arrow-orientation'] || 'left';
  const getArrowStyles = () => {
    switch (arrowOrientation) {
      case 'up':
        return {
          className:
            'absolute -top-2 left-1/2 transform -translate-x-1/2 border-b-8 border-b-white border-x-8 border-x-transparent',
          style: { width: 0, height: 0 },
        };
      case 'right':
        return {
          className:
            'absolute -right-2 top-1/2 transform -translate-y-1/2 border-l-8 border-l-white border-y-8 border-y-transparent',
          style: { width: 0, height: 0 },
        };
      case 'down':
        return {
          className:
            'absolute -bottom-2 left-1/2 transform -translate-x-1/2 border-t-8 border-t-white border-x-8 border-x-transparent',
          style: { width: 0, height: 0 },
        };
      case 'left':
      default:
        return {
          className:
            'absolute -left-2 top-1/2 transform -translate-y-1/2 border-r-8 border-r-white border-y-8 border-y-transparent',
          style: { width: 0, height: 0 },
        };
    }
  };

  const arrowStyles = getArrowStyles();

  return (
    <div className="fixed bg-white p-4 rounded-lg shadow-xl z-60 w-[300px]" style={style}>
      <div className={arrowStyles.className} style={arrowStyles.style} />
      <div className="flex items-center gap-4">
        <div className="shrink-0">
          <BouncingImage imageLink={step.image} width={5} />
        </div>
        <div className="grow">
          <p className="text-xl font-semibold mb-2">{step.title}</p>
          <p className="text-gray-600">{step.description}</p>
        </div>
      </div>
      <div className="mt-4 flex justify-between items-center">
        <div className="flex gap-1">
          {steps.map((s) => (
            <div
              key={s.id}
              className={`w-2 h-2 rounded-full ${s.id === step.id ? 'bg-blue-600' : 'bg-gray-300'}`}
            />
          ))}
        </div>
        <button
          onClick={isLastStep ? onComplete : onNext}
          disabled={nextButtonDisabled}
          className={`py-2 px-4 inline-flex items-center justify-center gap-x-2 text-sm font-medium rounded-lg border border-transparent ${
            nextButtonDisabled
              ? 'bg-gray-400 text-gray-200 cursor-not-allowed'
              : 'bg-blue-600 text-white hover:bg-blue-700 focus:outline-hidden focus:bg-blue-700'
          }`}
        >
          {isLastStep ? 'Finish' : 'Next'}
          <svg
            className="size-4"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M5 12h14" />
            <path d="m12 5 7 7-7 7" />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default TutorialTooltip;
